import React from 'react';
import {Link} from 'react-router-dom';
import i18n from 'i18n-react';
import logoDanone from '../images/logo-danone.png';
import logoEco from '../images/logo-eco.png';
export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: this.props.locale
    };
  }

  render() {
    return (
      <footer>
        <div className="container">
          <div className="box">
            <ul>
              <i18n.li text={{key: this.state.locale + ".footer.box1.title"}} className="title"/>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text1"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text2"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text3"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text4"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text5"}}/>
                </Link>
              </li>
            </ul>
          </div>
          <div className="box">
            <ul>
              <i18n.li text={{key: this.state.locale + ".footer.box2.title"}} className="title"/>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text1"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text2"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text3"}}/>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i18n.span text={{key: this.state.locale + ".footer.box1.text4"}}/>
                </Link>
              </li>
            </ul>
          </div>
          <div className="box">
            <ul>
              <i18n.li text={{key: this.state.locale + ".footer.box3.title"}} className="title"/>
              <ul className="rrss">
                <li>
                  <img src={logoEco} alt="Ecológico"/>
                </li>
              </ul>
            </ul>
          </div>
          <div className="box">
            <ul>
              <i18n.li text={{key: this.state.locale + ".footer.box4.title"}} className="title"/>
              <ul className="rrss">
                <li>
                  <Link to="https://www.facebook.com/las2vacas" target="_blank"><i className="fa fa-facebook" aria-hidden="true"></i></Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/las2vacas/" target="_blank"><i className="fa fa-instagram" aria-hidden="true"></i></Link>
                </li>
                <li>
                  <Link to="https://twitter.com/las2vacas" target="_blank"><i className="fa fa-twitter" aria-hidden="true"></i></Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/channel/UColqKsuVEhl76oPfPdm_tkw" target="_blank"><i className="fa fa-youtube" aria-hidden="true"></i></Link>
                </li>
              </ul>
            </ul>
          </div>
        </div>
        <div className="container bottom">
          <div>
            <i18n.p text={{key: this.state.locale + ".footer.bottom.title"}} className="title"/>
            <p>
              <i18n.span text={{key: this.state.locale + ".footer.bottom.text1"}}/>
              <i18n.span text={{key: this.state.locale + ".footer.bottom.text2"}}/>
            </p>
          </div>
          <div><img src={logoDanone} alt="Danone"/></div>
        </div>
      </footer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/Footer.js